"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sign_in_thunk = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var local_storage_names_1 = require("../../../../constants/local_storage_names");
var sign_in_1 = require("../../../../api/calls/client/sign_in");
var apis_1 = require("../../../../api/apis");
var main_1 = require("../../main");
var user_1 = require("../user");
var sign_in_thunk = (0, toolkit_1.createAsyncThunk)("user/sign_in_thunk", function (arg_1, _a) { return __awaiter(void 0, [arg_1, _a], void 0, function (arg, _b) {
    var user, response;
    var _c;
    var dispatch = _b.dispatch, getState = _b.getState;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                user = getState().userState.user;
                dispatch((0, user_1.setIsLoading)(true));
                return [4 /*yield*/, (0, sign_in_1.sign_in)({
                        email: (_c = user.email) !== null && _c !== void 0 ? _c : "",
                        password: user.password,
                    })];
            case 1:
                response = _d.sent();
                dispatch((0, user_1.setIsLoading)(false));
                if (response.success) {
                    if (user.remember_me) {
                        localStorage.setItem(local_storage_names_1.USER_LOCAL_STORAGE, JSON.stringify(response.content));
                    }
                    (0, apis_1.resetApiCaches)(dispatch);
                    dispatch((0, user_1.setUserToken)(response.content.token));
                    dispatch((0, user_1.setClientToken)(response.content.client_token));
                    dispatch((0, user_1.setMediaUploadToken)(response.content.media_upload_token));
                    dispatch((0, user_1.setPaymentEngineToken)(response.content.payment_engine_token));
                    dispatch((0, user_1.setUser)(response.content.user));
                }
                else {
                    dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
                }
                return [2 /*return*/, response];
        }
    });
}); });
exports.sign_in_thunk = sign_in_thunk;
